import { DriveDestinationCommand, toCommandCollectionRequest } from '@/drive/entities/DriveDestinationCommand';
import { BaseProductType } from '@/product/constants/productTypes';

export function getDriveDestinationProductType(command: DriveDestinationCommand): Nullable<BaseProductType> {
  return toCommandCollectionRequest(command)?.productType ?? null;
}
